
import { defineComponent } from 'vue'
import { Popover, Modal } from 'ant-design-vue'
import { CaretDownOutlined } from '@ant-design/icons-vue'

export default defineComponent({
    components: {
        Popover,
        CaretDownOutlined,
        Modal
    },
    props: {
        viewObj: {
            type: Object,
            default: () => {
                return {}
            }
        },
        selectRows: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    emits: ['cancelSelect'],
    setup (_props, { emit }) {
        const handleCancelSelect = () => {
            emit('cancelSelect');
        }
        // 批量删除客户组
        const handleBatchDeleteGroup = () => {
            Modal.confirm({
                title: '删除客户组',
                content: '删除客户组可能会对自动化、触发器、工单视图、社区目录权限等设置有影响，是否确定删除？',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    window.alert('等待对接api-删除客户组')
                }
            })
        }
        // 删除客户
        const handleDeleteUser = () => {
            Modal.confirm({
                title: '确定',
                content: '您确定要删除这些客户吗？',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    window.alert('等待对接api-删除这些客户')
                }
            })
        }
        // 将客户加入黑名单
        const handleAddblackList = () => {
            Modal.confirm({
                title: '加入黑名单确认',
                content: '您确定要将这些客户加入黑名单吗？',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    window.alert('等待对接api-加入黑名单确认')
                }
            })
        }
        // 移除黑名单
        const handleMoveUserfromBlacklist = () => {
            Modal.confirm({
                title: '移除黑名单确认',
                content: '您确定要将这些客户移出黑名单吗？',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    window.alert('等待对接api-移除黑名单确认')
                }
            })
        }

        return {
            handleCancelSelect,
            handleBatchDeleteGroup,
            handleDeleteUser,
            handleAddblackList,
            handleMoveUserfromBlacklist
        }
    }
})
